// WordPress core REST namespace. The blog base URL is normalized to `/wp-json`
// (the trailing `/wp` is stripped in the client/proxy), so core endpoints carry
// their `wp/v2` namespace here and custom namespaces (e.g. BLOG_VIEW's `debut/v1`)
// sit as siblings under `/wp-json` rather than incorrectly nested under `/wp`.
const namespaces = 'wp/v2';

const API_URL = {
    BLOGS_LISTING: `${namespaces}/posts`,
    BLOGS_DETAILS: `${namespaces}/posts`,
    NEWS_LISTING: `${namespaces}/news`,
    NEWS_DETAILS: `${namespaces}/news`,
    ADD_COMMENT: `${namespaces}/comments`,
    COMMENT_LISTING: `${namespaces}/comments`,
    CATEGORIES_TYPES: `${namespaces}/categories`,
    CONTACT_US: `/contact-us`,
    EXPERT_TALK: `/quote-chicago`,
    USE_CASE_CATEGORIES: `${namespaces}/use_cases_categories`,
    USE_CASE: `${namespaces}/use_case`,
    BLOG_VIEW: `debut/v1/posts`
};

export default API_URL;
